export const SINGLE_BRAND_SINGLE_OUTLET = {
  id: "single_brand_single_outlet",
  label: "Single Brand Single Outlet"
};
export const MULTIPLE_BRAND_SINGLE_OUTLET = {
  id: "multiple_brand_single_outlet",
  label: "Multiple Brand Single Outlet"
};

export const BUSINESSTYPES = [
  SINGLE_BRAND_SINGLE_OUTLET,
  MULTIPLE_BRAND_SINGLE_OUTLET
];
